import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=c3ddc4e4&scoped=true&lang=pug&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ddc4e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ddc4e4')) {
      api.createRecord('c3ddc4e4', component.options)
    } else {
      api.reload('c3ddc4e4', component.options)
    }
    module.hot.accept("./VButton.vue?vue&type=template&id=c3ddc4e4&scoped=true&lang=pug&", function () {
      api.rerender('c3ddc4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/VButton.vue"
export default component.exports